import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as types from '@/vdp/VehicleDetailsContainer/actionTypes';
import { getUser, getVehicleId } from '~/selectors';
import { fetchFavorites } from '~/services/common';
import { FavoritesResponse } from '~/services/common/contracts';
import debounce from '~/utilities/debounce';

const getFavoritesLoading = () => ({
  type: `${types.GET_FAVORITES}_LOADING`
});

const getFavoritesSuccess = (payload: FavoritesResponse) => ({
  type: `${types.GET_FAVORITES}_SUCCESS`,
  payload
});

const getFavoritesError = (payload: any) => ({
  type: `${types.GET_FAVORITES}_ERROR`,
  error: true,
  payload
});

export const setCurrentVehicleFavorited = (payload: {
  isFavorited: boolean;
  isSubscribedToNotifications?: boolean;
}) => ({
  type: types.SET_CURRENT_VEHICLE_FAVORITED,
  payload
});

function useGetFavorites() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(getUser);
  const vehicleId = useSelector(getVehicleId);

  return useMemo(
    () =>
      debounce(async () => {
        if (!isLoggedIn) return;

        try {
          dispatch(getFavoritesLoading());
          const { data } = await fetchFavorites();
          dispatch(getFavoritesSuccess(data));
          const currentVehicle = data.vehicles.find(
            vehicle => vehicle.vehicleId === vehicleId
          );
          dispatch(
            setCurrentVehicleFavorited({
              isFavorited: Boolean(currentVehicle),
              isSubscribedToNotifications:
                currentVehicle?.subscribeToWIPNotifications ?? false
            })
          );
        } catch (err) {
          dispatch(getFavoritesError(err));
        }
      }, 1000),
    [dispatch, isLoggedIn, vehicleId]
  );
}

export default useGetFavorites;
